module.exports = __webpack_public_path__ + "static/media/submit-a-case.36207638.svg";